module.exports = __webpack_public_path__ + "static/img/lucre-games-indie-game-sacramento-logo-black.b25a834.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lucre-games-indie-game-sacramento-logo-black.png
// module id = c119
// module chunks = 0